import React from 'react'

const NotFound: React.FC = () => {
  return (
    <div>
      <h1>Not found!!!</h1>
    </div>
  )
}

export default NotFound
